"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const _1 = require("../.");
function withFormControl(InputComponent) {
    // eslint-disable-next-line react/display-name
    return (props) => {
        const { formControlProps, inputProps, } = (0, _1.useControlLogic)(InputComponent, props);
        return (react_1.default.createElement(_1.FormControl, Object.assign({}, formControlProps),
            react_1.default.createElement(InputComponent, Object.assign({}, inputProps))));
    };
}
exports.default = withFormControl;
